module.exports = __webpack_public_path__ + "14_hair_gold.e9f4b710.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/14_hair_gold.png
// module id = unuz
// module chunks = 0